<template>
  <div class="contract-detail">
    <div class="header">
      <span>{{ info.contractName }}</span>
      <el-tag class="audit-state" :type="stateType[info.state]">{{ info.auditState }}</el-tag>
    </div>
    <div class="info-wrap">
      <div class="info-item" v-for="item in infoItems" :key="item.prop">
        <span class="item-label">{{ item.label }}</span>
        <span class="item-value">{{ info[item.prop] }}</span>
      </div>
    </div>
    <el-tabs class="tab-content" v-model="activeTab" v-if="!loading">
      <el-tab-pane label="跟进记录" name="follow" lazy>
        <detail-follow :contract="info"></detail-follow>
      </el-tab-pane>
      <el-tab-pane label="合同动态" name="dynamic" lazy>
        <detail-dynamic :id="contractId" :getLogs="getDynamicLogs"></detail-dynamic>
      </el-tab-pane>
      <el-tab-pane label="回款" name="receipt" lazy>
        <detail-receipt :contract="info" />
      </el-tab-pane>
      <el-tab-pane label="附件" name="attach" lazy>
        <detail-attach :contract="info" />
      </el-tab-pane>
      <el-tab-pane label="详细资料" name="details" lazy class="details">
        <info-items :items="detailItems" :info="info"></info-items>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DetailDynamic from "@/views/components/detail-dynamic";
import InfoItems from "@/views/components/info-items";
import DetailFollow from "./detail/detail-follow";
import DetailAttach from "./detail/detail-attach";
import DetailReceipt from "./detail/detail-receipt";
import NewTable from "@/components/new-table";
import { ContractApis } from "@/apis";
import { AuditState } from "@/utils/enum";
export default {
  name: "contract-detail",
  data() {
    return {
      contractId: this.$route.query.id,
      loading: true,
      info: {},
      infoItems: [
        { label: "客户名称", prop: "customerName" },
        { label: "合同金额（元）", prop: "contractAmount" },
        { label: "签订日期", prop: "signDate" },
        { label: "回款金额（元）", prop: "collectionAmount" },
        { label: "负责人", prop: "chargeName" },
      ],
      activeTab: "follow",
      detailItems: [
        { label: "合同编号", prop: "contractNo" },
        { label: "合同名称", prop: "contractName" },
        { label: "客户名称", prop: "customerName" },
        { label: "合同金额", prop: "contractAmount" },
        { label: "签订日期", prop: "signDate" },
        { label: "合同开始日期", prop: "startDate" },
        { label: "合同结束日期", prop: "endDate" },
        { label: "客户签约人", prop: "linkName" },
        { label: "公司签约人", prop: "chargeName" },
        { label: "合同类型", prop: "contractTypeName" },
        { label: "备注", prop: "remark", class: "full-width" },
      ],
      getDynamicLogs: ContractApis.getContDynamicLogs,
      stateType: {
        0: "warning",
        1: "success",
        2: "danger",
        3: "info",
      },
    };
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    async getDetailInfo() {
      const res = await ContractApis.getContractById(this.contractId);
      res.auditState = AuditState[res.state];
      res.signDate = res.signDate && res.signDate.slice(0, 11);
      res.startDate = res.startDate && res.startDate.slice(0, 11);
      res.endDate = res.endDate && res.endDate.slice(0, 11);
      this.info = res;
      this.loading = false;
    },
  },
  components: { DetailFollow, InfoItems, DetailDynamic, DetailAttach, DetailReceipt, NewTable },
};
</script>

<style scoped lang="scss">
.contract-detail {
  flex-direction: column;
  overflow: auto;
}
.header {
  line-height: 28px;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  .audit-state {
    margin-left: 15px;
  }
}
.info-wrap {
  padding: 20px 30px;
  background-color: #eff6ff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 15px 0;
  .info-item {
    line-height: 1;
  }

  .item-value {
    display: inline-block;
    padding-left: 16px;
    font-weight: bold;
  }
}

.details {
  padding-left: 50px;
  padding-right: 20px;
  max-width: 1000px;
  flex: 1;
  overflow: auto;
}
</style>
